// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__WGJmL","content":"styles_content__MqnwM","information":"styles_information__Qq0HJ","icon":"styles_icon__nzixE"};